import React from "react"
import { Button } from "@chakra-ui/react"
import { Link } from "components/Link"

export type Cta = {
  text: string
  link: string
  type?: string
  size?: string
  target?: string
  linkTitle?: string
}

type Props = {
  cta: Cta
}

export const RichTextButton: React.FC<Props> = ({ cta }) => {
  const { text, link, type, size, target, linkTitle } = cta
  return (
    <Button
      as={Link}
      variant={type || "primary"}
      size={size || "medium"}
      href={link}
      target={target === "same" ? "_self" : "_blank"}
      title={linkTitle || text}
    >
      {text.toUpperCase()}
    </Button>
  )
}
